import React, { useState, useEffect } from 'react';

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 根据当前访问地址自动判断 API 地址
  const API_BASE = process.env.REACT_APP_API_BASE || 
    (window.location.hostname === 'localhost' ? 'http://localhost:8000' : window.location.origin);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('admin_token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  };

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/admin/dashboard`, {
          headers: getAuthHeaders(),
        });
        if (response.ok) {
          const data = await response.json();
          setDashboardData(data);
        }
      } catch (err) {
        console.error('获取仪表盘数据失败:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);

  if (loading) {
    return <div style={{ padding: 24 }}>加载中...</div>;
  }

  if (!dashboardData) {
    return <div style={{ padding: 24 }}>暂无数据</div>;
  }

  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ marginBottom: 24 }}>仪表盘</h1>
      
      {/* 用户统计 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, marginBottom: 24 }}>
        <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <div style={{ color: '#666', fontSize: 14, marginBottom: 8 }}>总用户数</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#1a1f36' }}>{dashboardData.users?.total || 0}</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>今日新增: {dashboardData.users?.today_new || 0}</div>
        </div>
        <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <div style={{ color: '#666', fontSize: 14, marginBottom: 8 }}>活跃用户</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#1a1f36' }}>{dashboardData.users?.active || 0}</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>今日登录: {dashboardData.users?.today_login || 0}</div>
        </div>
        <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <div style={{ color: '#666', fontSize: 14, marginBottom: 8 }}>今日文档</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#1a1f36' }}>{dashboardData.documents?.today || 0}</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>本周: {dashboardData.documents?.week || 0}</div>
        </div>
        <div style={{ background: '#fff', padding: 20, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <div style={{ color: '#666', fontSize: 14, marginBottom: 8 }}>本月文档</div>
          <div style={{ fontSize: 28, fontWeight: 600, color: '#1a1f36' }}>{dashboardData.documents?.month || 0}</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>累计生成</div>
        </div>
      </div>

      {/* 模块使用统计 */}
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: 24 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>模块使用统计</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
          <div style={{ textAlign: 'center', padding: 16, background: '#f9fafb', borderRadius: 8 }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📄</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{dashboardData.modules?.document || 0}</div>
            <div style={{ fontSize: 12, color: '#666' }}>公文排版</div>
          </div>
          <div style={{ textAlign: 'center', padding: 16, background: '#f9fafb', borderRadius: 8 }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📅</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{dashboardData.modules?.schedule || 0}</div>
            <div style={{ fontSize: 12, color: '#666' }}>行程安排</div>
          </div>
          <div style={{ textAlign: 'center', padding: 16, background: '#f9fafb', borderRadius: 8 }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>🏷️</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{dashboardData.modules?.tableSign || 0}</div>
            <div style={{ fontSize: 12, color: '#666' }}>台签生成</div>
          </div>
          <div style={{ textAlign: 'center', padding: 16, background: '#f9fafb', borderRadius: 8 }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📋</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>{dashboardData.modules?.unitSort || 0}</div>
            <div style={{ fontSize: 12, color: '#666' }}>单位排序</div>
          </div>
        </div>
      </div>

      {/* 近7天趋势 */}
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>近7天文档生成趋势</h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 150 }}>
          {dashboardData.trend?.map((item, index) => {
            const maxCount = Math.max(...(dashboardData.trend?.map(t => t.count) || [1]));
            const height = maxCount > 0 ? (item.count / maxCount) * 120 : 0;
            return (
              <div key={index} style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ 
                  height: Math.max(height, 4), 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  borderRadius: '4px 4px 0 0',
                  marginBottom: 8
                }} />
                <div style={{ fontSize: 12, color: '#666' }}>{item.date.slice(5)}</div>
                <div style={{ fontSize: 11, color: '#999' }}>{item.count}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
